export default __webpack_public_path__ + "static/media/Ellipse 1.95048037.svg";